import type { Deck } from "@punkrecords/types";

export function serializeDecks(decks: Deck[]): string {
  return JSON.stringify(decks);
}

export function deserializeDecks(json: string): Deck[] {
  const parsed = JSON.parse(json);
  if (!Array.isArray(parsed)) return [];
  return parsed.filter(isDeckShape);
}

function isDeckShape(value: unknown): value is Deck {
  if (typeof value !== "object" || value === null) return false;
  const obj = value as Record<string, unknown>;
  return (
    typeof obj.id === "string" &&
    typeof obj.name === "string" &&
    (obj.leader === null || typeof obj.leader === "string") &&
    Array.isArray(obj.cards) &&
    typeof obj.createdAt === "number" &&
    typeof obj.updatedAt === "number" &&
    (obj.format === undefined || obj.format === "constructed" || obj.format === "sealed") &&
    (obj.sealedSet === undefined || typeof obj.sealedSet === "string")
  );
}

export function createEmptyDeck(name?: string): Deck {
  const id =
    typeof crypto !== "undefined" && crypto.randomUUID
      ? crypto.randomUUID().slice(0, 8)
      : Math.random().toString(36).slice(2, 10);

  const now = Date.now();
  return {
    id,
    name: name ?? "New Deck",
    leader: null,
    cards: [],
    createdAt: now,
    updatedAt: now,
  };
}
